import React from 'react';
import BackButton from './backButton';

const WetBasementService = () => {
    return (
        <div className="container mx-auto p-4 pt-28">
            <h1 className="text-3xl font-semibold mb-4">Wet Basement Service</h1>


            <BackButton />

            <p>
                If you're dealing with a cracked foundation or a block wall that's allowing water to infiltrate, it's crucial to explore our foundation repair page for more information on how to address a wet basement and its repairs.
            </p>
            <br />
            <p>
                A wet basement can be a persistent issue caused by hydraulic-hydrostatic pressure. This problem often results from collapsed or clogged weeping tiles or the absence of these drainage systems altogether. When this happens, water is unable to be efficiently removed from beneath the house's slab, leading to a persistently wet basement. To rectify this issue, we typically install new weeping tile systems, either on the interior or exterior of your property, often in conjunction with a sump pump.
            </p>

            <div className="flex flex-wrap justify-center">
                <div className=" p-2 ">
                    <img src="\images\services\wet-basement\French Drain subpump.webp" className="rounded-lg shadow-lg w-2/3 mx-auto" alt="French Drain Subpump" />
                    <p className="text-center mt-2">French Drain Subpump - Used to pump water from the basement out.</p>
                </div>
            </div>


            <p>
                One of our most commonly employed solutions is an interior repair known as a French drain or an internal weeping tile system with a sump pump. If you're looking to put an end to your wet basement woes, don't hesitate to request a quote for the necessary repairs.
            </p>

            <div className="flex flex-wrap justify-center">
                <div className=" p-2">
                    <img src="\images\services\wet-basement\French Drain.webp" className="rounded-lg shadow-lg mx-auto h-80" alt="French Drain" />
                    <p className="text-center mt-2">French Drain - Drains are for sending the water away from the foundation.</p>
                </div>
            </div>

            <p>
                The repair process involves breaking up the floor along the areas with leaking walls, followed by excavation to create a trench. In this trench, a four-inch perforated weeping tile or filtered o-pipe is placed and then covered with clean gravel to facilitate drainage. All excavated materials are thoroughly removed from the site, and the trench is recemented with concrete.
            </p>

            <div className="flex flex-wrap justify-center">
                <div className=" p-2">
                    <img src="\images\services\wet-basement\sump-pump.webp" alt="Sump Pump" className="rounded-lg shadow-lg mx-auto" />
                    <p className="text-center mt-2">Sump Pump - The pump used in installations.</p>
                </div>
            </div>

            <p>
                French drains are a versatile solution that can be installed in two different ways around a home's foundation:
            </p>

            <ul className=''>
                <li>- Buried around the foundation wall on the external side.</li>
                <li>- Installed underneath the basement floor on the inside perimeter.</li>
            </ul>
            <br />
            <p>
                In most homes, an external French drain or drain tile is installed around the foundation walls before backfilling the foundation soil. It's placed at the bottom of the excavated area, covered with a layer of stone, and then the area is backfilled. Maintenance is minimal, and the system typically remains trouble-free unless it becomes clogged.
            </p>
            <br />
            <p>
                Interior French drain installation is usually carried out after a house has been built, often in response to a wet basement issue or just before a basement finishing project. This involves jackhammering the perimeter of the basement floor down to the footing and removing the cement. A layer of stone is then laid, and the drain is placed on top. Water is collected from the basement wall-floor joint as it enters, and a sump pump is installed to pump the water out of the house and away from the foundation.
            </p>
            <br />
            <p>
                Once completed, the area is cemented over. This can be installed very quickly - 1-2 days by an experienced crew. The system is easy to maintain once installed, and the sump pump will need annual maintenance to perform properly. An interior French drain is much less likely to clog than an exterior, partially due to the fact that it is not sitting underneath several feet of soil.
            </p>
            <br />
            <p>
                Interior French drain installation is an effective way to waterproof a wet basement but requires the use of a sump pump. Many contractors will install plastic sump pumps that can quickly break down or neglect to install a battery backup sump pump, making the basement vulnerable to flooding during power outages, but this is optional. These are some of the considerations to think about when you get this work done.
            </p>
            <br />

        </div>
    );
};

export default WetBasementService;
